<div class="general">
  <div class="general-fix">
    <div class="img-size">
      <img src="assets/logo-dabnet.png" alt="" />
    </div>
    <div class="title-p1">404!</div>
    <div class="title-p2">Üzgünüz.</div>
    <div class="title-p2">DabNet Kamu Aradığınız Sayfayı Bulamadı...</div>
    <a *ngIf="isShow" class="title-p3" [routerLink]="['/main/dabnet']">
      AnaSayfa'ya geri dön
    </a>
  </div>
</div>
